<template>
  <Section>
    <Container>
      <FadeIn>
        <div class="md:max-w-[75%] lg:max-w-[50%]">
          <h2 class="text-section-title">{{ content.title }}</h2>
          <p class="text-subtitle">{{ content.subtitle }}</p>
        </div>
        <div class="mt-8 lg:mt-16 grid grid-cols-1 md:gap-x-16 md:grid-cols-2">
          <div v-for="item in content.items" class="relative border-b border-[#e8e5de] py-4 md:py-6">
            <div class="font-bold text-gray-900 text-lg">{{ item.compliance_item_id.title }}</div>
            <div class="mt-2" v-html="item.compliance_item_id.content"></div>
          </div>
        </div>
      </FadeIn>
    </Container>
  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>